import React, { useEffect, useState } from "react";
import { Timer } from "lucide-react";

function formatDuration(since) {
  const secs = Math.max(0, Math.floor((Date.now() - new Date(since).getTime()) / 1000));
  const mins = Math.floor(secs / 60);
  if (mins < 1) return "just now";
  const d = Math.floor(mins / 1440);
  const h = Math.floor((mins % 1440) / 60);
  const m = mins % 60;
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
}

// Subtle live ticker: "Leading for 3h 12m", refreshes every minute.
export function LeadingFor({ since, className = "" }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!since) return;
    const t = setInterval(() => setTick((x) => x + 1), 60000);
    return () => clearInterval(t);
  }, [since]);
  if (!since) return null;
  const label = formatDuration(since);
  return (
    <span data-testid="leading-for" className={`inline-flex items-center gap-1 text-white/45 ${className}`}>
      <Timer className="w-3 h-3" />
      {label === "just now" ? "Just took the lead" : `Leading for ${label}`}
    </span>
  );
}
